export class PageComponents {
  constructor() {
    this.global = true;
    this.advantage = true;
    this.footer = true;
    this.header = true;
    this.newsletter = true;
    this.breadcrumbs = true;
    this.customComponents = null;
  }
  static fromBuilder(data) {
    const model = new PageComponents();
    model.global = data.global ?? false;
    model.advantage = data.advantage ?? false;
    model.footer = data.footer ?? false;
    model.header = data.header ?? false;
    model.newsletter = data.newsletter ?? false;
    model.breadcrumbs = data.breadcrumbs ?? false;
    model.customComponents = data.customComponents ?? [];
    return model;
  }
}
